import { PriceValidation, StoreCart } from '@/types/store'
import { useCallback, useRef, useState } from 'react'

export function usePriceChangeDetection() {
  const [showPriceChangeModal, setShowPriceChangeModal] = useState(false)
  const [preservedPriceValidation, setPreservedPriceValidation] = useState<PriceValidation | null>(null)
  const hasShownModalRef = useRef(false)

  const checkForPriceChanges = useCallback((cart: StoreCart | null) => {
    if (cart?.priceValidation?.hasPriceChanges && !hasShownModalRef.current) {
      // Preserve the priceValidation data when first showing the modal
      // This prevents the modal from closing if the cart updates and clears priceValidation
      setPreservedPriceValidation(cart.priceValidation)
      setShowPriceChangeModal(true)
      hasShownModalRef.current = true
      return true
    }
    return false
  }, [])

  const closePriceChangeModal = useCallback(() => {
    setShowPriceChangeModal(false)
    setPreservedPriceValidation(null)
    hasShownModalRef.current = false
  }, [])

  return {
    showPriceChangeModal,
    checkForPriceChanges,
    closePriceChangeModal,
    preservedPriceValidation, // Return the preserved validation data
  }
}
